<template>
  <div>
    <div class="container">
    <h1>Aktive Angebote</h1>
    </div>
    <div class="list">
        <div class="container">
          <div class="row">
            <div class="col-12">
            <Angebot :Angebote="Angebote" v-bind:id="Angebote.persistence_object_identifier" :user="User" :show-freigegeben="false"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Angebot from "@/components/angebot/admin/Angebot";
import AngebotService from "../../services/AngebotService";
//import Modal from "./Show";

export default {
  name: "ListeAktiv",
  components: {
    Angebot,
    //Modal
  },
  data() {
    return {
      Angebote: [],
      User: Object
    }
  },
  methods:{
      showModal(id){
        this.$refs.modal.showIt(id)
      },
    refreshAngebote(){
      AngebotService.getAngeboteAktiv()
              .then(response => {
                let angebotData = Object.keys(response.data).map(function(key) {
                  return [Number(key), response.data[key]];
                });

                this.Angebote = angebotData;


              })
              .catch(error => {
                console.log("There was an error:", error.response);
              });
    },

  },
  created() {
    let user = this.$store.getters.userObject;
    this.User = user;
    AngebotService.getAngeboteAktiv()
      .then(response => {
        let angebotdata = response.data;

        console.log('Got all Angebote', typeof angebotdata)
        this.Angebote = Object.freeze(angebotdata); // <--- set the events when returned
        
      })
      .catch(error => {
        console.log("There was an error:", error.response);
      });
  },
 

};
</script>
